import { NgIf, AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { SelectedCustomer, SelectedLocation, UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { FeedAdvice, InputSystemType, ParityType } from '../../../models/feed-advice.model';

@Component({
  selector: 'app-sows-feed-advice-report',
  templateUrl: './sows-feed-advice-report.component.html',
  styleUrls: ['./sows-feed-advice-report.component.scss'],
  imports: [NgIf, AsyncPipe, TranslatePipe],
})
export class SowsFeedAdviceReportComponent {
  @Input() advice: FeedAdvice;
  @Input() parityCategory: ParityType;
  @Input() inputSystem: InputSystemType;
  customer$: Observable<SelectedCustomer> = this.store.select(UserSelectors.selectCustomer);
  location$: Observable<SelectedLocation> = this.store.select(UserSelectors.selectLocation);

  constructor(private readonly store: Store<RootState>) {}
}
